export const COLORS = {
  PRIMARY: '#ffd129ff',
  SECONDARY: '#e3bd16ff',
} as const;